import { Component, OnInit } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal";
import { AuthService } from "@city-tax/features/auth";

@Component({
  selector: "city-tax-feature-instructions",
  templateUrl: "./instructions.component.html",
  styleUrls: ["./instructions.component.scss"]
})
export class InstructionsComponent implements OnInit {

  public config = this.authService.config;

  constructor(
    public bsModalRef: BsModalRef,
    private authService: AuthService
  ) {
  }

  ngOnInit(): void {
  }

}
